import { render, staticRenderFns } from "./tuzhuanglinxihetong.vue?vue&type=template&id=5b0c9f6e&scoped=true&"
import script from "./tuzhuanglinxihetong.vue?vue&type=script&lang=js&"
export * from "./tuzhuanglinxihetong.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0c9f6e",
  null
  
)

export default component.exports